<div class="row">
  <div class="col">
    <h2>Co-Applicant Home</h2>
  </div>
</div>

<form [formGroup]="coApplicantRentFormGroup">
  <app-rent-vehicle-group
    [controls]="coApplicantRentFormGroup.controls"
  ></app-rent-vehicle-group>
</form>

<hr class="hr-style" />

<div class="row my-5">
  <div class="col-12 col-lg-6">
    <button type="button" class="btn btn-primary" (click)="onNext()">
      Continue to Co-Applicant Employer
      <i class="bi bi-chevron-right"></i>
    </button>

    <app-validation-text
      [show]="isDirtyAndMissingRequiredFields"
    ></app-validation-text>
  </div>
  <div class="col-12 col-lg-6">
    <div class="mt-3 mt-lg-0 text-center text-md-start text-lg-end">
      <button class="btn btn-link" (click)="onFinishByPhone()">
        <small> Finish Application by Phone </small>
      </button>
    </div>
  </div>
</div>
